// extracted by mini-css-extract-plugin
export default {"root":"Rdido","text":"j0ocd","title":"iwJMD","description":"YAe5i"};